import Number from '../../components/Number.vue';
import Options from '../../componentsToQuestions/Options.vue';
import { mapState } from 'vuex';

export default {
    props: ['index'],
    components: { Number, Options },
    watch: {
        options(value) {
            this.questionsByPage[this.index].properties.max = value.length;
        },
    },
    methods: {
        /**
         * Valida si el valor máximo configurado es mayor a la cantidad de opciones.
         * @param {number} $event
         */
        validateMax($event) {
            if ($event > this.lengthOptions) this.questionsByPage[this.index].properties.max = this.lengthOptions;
        },
        /**
         * Valida si el valor mínimo configurado es mayor al valor máximo.
         * @param {number} $event
         */
        validateMin($event) {
            if ($event > this.maxi) this.questionsByPage[this.index].properties.min = this.maxi;
        }
    },
    computed: {
        ...mapState('resource', ['questionsByPage']),
        /**
         * Obtiene la longitud del array.
         */
        lengthOptions() {
            return this.options.length;
        },
        /**
         * Obtiene un valor booleano para saber si la pregunta es requerida.
         */
        required() {
            return this.questionsByPage[this.index].required;
        },
        /**
         * Obtiene la lista de ocpiones del componete.
         */
        options() {
            return this.questionsByPage[this.index].options;
        },
        /**
         * Verifica sí la pregunta es requerida y establece en 1 el valor minimo a seleccionar.
         */
        miniRequired() {
            if (this.required === true) return 1;
            return 0;
        },
        /**
         * Obtiene el valor mínimo de opciones a seleccionar.
         */
        mini() {
            return this.questionsByPage[this.index].properties.min;
        },
        /**
         * Obtiene el valor máximo de opcines a seleccionar.
         */
        maxi() {
            return this.questionsByPage[this.index].properties.max;
        }
    }
}
